<page-content [fullPageWidth]="true">
    <header-elitment header
            [hasSideMenu]="true">
    </header-elitment>
    <side-menu left-menu
               [neverHide]="isEditMode">
        <athlete-side-menu *ngIf="!isEditMode"></athlete-side-menu>
        <annual-plan-side-menu-week-edit
            [addRealWeekNumber]="true"
            (weekSelectedEvent)="weekEventClicked($event)"
            (weekToUpdateEvent)="weekUpdated($event)"
            [organization]="organization"
            [annualPlan]="annualPlan"
            [clickedWeek]="clickedWeek!"
            [weeks]="weeks"
            *ngIf="isEditMode"></annual-plan-side-menu-week-edit>
    </side-menu>

    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>
    <module-content *ngIf="!is401 && !is404"
                    [title]="annualPlan.title??''"
                    [titleSwitcher]="titleSwitcherItems"
                    [mainActions]="mainActions"
                    class="main-container">

        <!--
        <nav id="secondary-nav-old" *ngIf="isEditMode">
            <ul>
                <li><button (click)="onPhaseDialogClicked()" mat-mini-fab>+</button> Phase</li>
                <li><button (click)="onMacrocycleDialogClicked()" mat-mini-fab color="accent">+</button> Macrocycle</li>
            </ul>
        </nav>
                <nav id="secondary-nav" *ngIf="isEditMode">
            <ul>
                <li><button (click)="onPhaseDialogClicked()" mat-mini-fab>+</button> Phase</li>
            </ul>
        </nav>
        -->

        <nav id="secondary-nav">
            <ul>
                <li>
                    <button *ngIf="!isEditMode && annualPlanRights.getItemRightsList().edit"
                            mat-mini-fab
                            [matTooltip]="'Export_plan' | translate"
                            color="none"
                            (click)="attributeEvent()">
                        <i class="material-icons">
                            how_to_reg
                        </i>
                    </button>
                    <button *ngIf="!isEditMode && annualPlanRights.getItemRightsList().edit"
                            mat-mini-fab
                            [matTooltip]="'Make_a_model' | translate"
                            color="none"
                            (click)="onDuplicateAsModel()">
                        <i class="material-icons">
                            book
                        </i>
                    </button>
                </li>
            </ul>
        </nav>

        <p class="text-center">{{ 'AnnualPlan_WeeklyWorkingTime' | translate:{'time': annualPlan.weeklyWorkingTime | secondsToDHM | default:'-' } }}</p>

        <div fxLayout="row" fxLayoutAlign="end center" *ngIf="!isEditMode">
            <div>
                <mat-slide-toggle (change)="toggleEffectivePlan($event)">{{ 'EffectivePlan'|translate }}</mat-slide-toggle>
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-md="column" fxLayoutGap="20px" class="graphs-row">
            <div [fxFlex]="showEffectivePlan ? 50 : 100" class="track-scrolling">
                <app-annual-plan-graph
                    (weekSelectedEvent)="weekEventClicked($event)"
                    (annualPlanPhaseClickedEvent)="annualPlanPhaseClickedEvent($event)"
                    (annualPlanMacroCycleClickedEvent)="annualPlanMacroCycleClickedEvent($event)"
                    (addMacroCycleEvent)="addMacroCycleEvent($event)"
                    (addPhaseEvent)="addPhaseEvent($event)"
                    [organization]="organization"
                    [annualPlan]="annualPlan"
                    [weeks]="weeks"
                    [annualPlanPhases]="annualPlanPhases"
                    [annualPlanMacroCycles]="annualPlanMacroCycles"
                    [clickedWeek]="clickedWeek"
                    [isEditMode]="isEditMode"
                    (graphScrollPosition)="handleGraphScroll($event)"
                    [scrollPosition]="scrollPosition ?? undefined"
                    [showMonths]=true
                ></app-annual-plan-graph>
            </div>
            <div fxFlex="50" class="track-scrolling">
                <app-effective-plan-graph *ngIf="!isLoading && showEffectivePlan"
                    [organization]="organization"
                    [athlete]="athleteUser.athlete!"
                    [annualPlanId]="annualPlan.id"
                    (graphScrollPosition)="handleGraphScroll($event)"
                    [scrollPosition]="scrollPosition ?? undefined"
                    [showMonths]=true
                ></app-effective-plan-graph>
            </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="start">
            <div fxFlex="50">
                <div class="plan-legend">
                    <h3>{{ 'Planning' | translate }}</h3>
                    <ul>
                        <li><span class="bullet intensity"></span> {{ 'intensity' | translate }}</li>
                        <li><span class="bullet physical"></span> {{ 'physical' | translate }}</li>
                        <li><span class="bullet sport"></span> {{ 'sport' | translate }}</li>
                    </ul>
                </div>

                <div class="plan-legend">
                    <h3>{{ 'Accents' | translate }}</h3>
                    <ul>
                        <li *ngFor="let category of exerciseCategories"><span class="bullet" [ngStyle]="{'background': category.colorHex}"></span> {{ category.name }}</li>
                    </ul>
                </div>

                <div class="plan-legend">
                    <h3>{{ 'phases' | translate }}</h3>
                    <ul>
                        <li *ngFor="let phase of phases"><span class="bullet" [ngStyle]="{'background': phase.hexadecimalColor}"></span> {{ phase.name }}</li>
                    </ul>
                </div>
            </div>
            <div fxFlex="50">
                <div class="annual-plan-season-goals">
                    <h3>{{ 'title.season_objective' | translate }}</h3>
                    <div *ngIf="!isEditMode">{{ !isEditMode && annualPlan.comment || '-' }}</div>

                    <form [formGroup]="annualPlanForm" *ngIf="isEditMode">
                        <fieldset [disabled]="isSubmitting">
                            <mat-form-field [floatLabel]="'auto'">
                                <textarea
                                    matInput
                                    cdkTextareaAutosize
                                    formControlName="comment"
                                    class="default"
                                    (change)="onChangeComment()"
                                    ></textarea>
                                <mat-error *ngIf="f['comment'].errors">{{ 'validator.comment.max_length' | translate }}</mat-error>
                            </mat-form-field>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
        <ng-container *ngIf="!isEditMode && annualPlanRights.getItemRightsList().edit">
            <main-action [title]="'Edit'"
                         [icon]="'edit'"
                         [isLoading]="isLoading"
                         [disabled]="isLoading"
                         [link]="'/' + organization.code + '/athletes/' + athleteUser.id + '/plans/' + annualPlan.id + '/edit'">
            </main-action>
        </ng-container>

        <ng-container *ngIf="isEditMode && annualPlanRights.getItemRightsList().edit">
            <main-action [title]="'Save'"
                         [icon]="'check'"
                         [isLoading]="isLoading"
                         [disabled]="isLoading"
                         (click)="onSaveClicked()">
            </main-action>
            <main-action [title]="'Close_edit_mode'"
                         [icon]="'close'"
                         [color]="'none'"
                         [right]="104"
                         [link]="'/' + organization.code + '/athletes/' + athleteUser.id + '/plans/' + annualPlan.id">
            </main-action>
        </ng-container>
    </module-content>
</page-content>
